import { angularFileUpload, IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IProfilePlan, IUserProfile, UserProfile } from '../../entities/profile';
import { Candidate, ICandidate } from '../../entities/candidate';
import { ICv } from '../../entities/cv';
import { cloneDeep, get } from 'lodash-es';
import { IServerRes } from '../../interfaces';
import { EmployerJobExperience, IEmployerJobExperience } from '../../entities/employer-job-experience';
import { CompanyData, ICompanyData } from '../../entities/company-data';
import { IUploadFileResult } from '../../interfaces/upload-file-response.interface';
import { UserService } from '../user/user.service';
import { IHiringOn, IHiringOnUpdateData } from '../../entities/hiring-on';


export class ProfileService {
  static $inject = [
    '$http',
    'GmcApi',
    'Upload'
  ];
  navigationUnlocked = true;
  cvPoints = 0;
  profile: UserProfile;

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi,
               private uploadService: angularFileUpload.IUploadService,
               private userService: UserService ) {
  }

  getProfile(): IPromise<UserProfile> {
    return this.$http.get(this.gmcApi.user.getProfile)
      .then(( res ) => {
          this.profile = new UserProfile(res.data);
          this.checkFieldsForNavigation();
          return this.profile;
        }
      );
  }

  refetchProfile() {
    // this.getProfile()
    //   .catch(( err ) => console.log(err));
  }

  updateCandidateProfile( candidate: ICandidate ): IPromise<Candidate> {
    return this.$http.post(this.gmcApi.user.updateCandidateProfile, { candidate })
      .then(( res ) => {
        Object.assign(this.profile.candidate, cloneDeep(candidate));
        this.checkFieldsForNavigation();
        this.getFillPoints();
        return this.profile.candidate;
      });
  }

  updateCandidateCv( cv: ICv ): IPromise<UserProfile> {
    return this.$http.post(this.gmcApi.user.updateCandidateProfile, { candidate: { cv } })
      .then(( res ) => {
        Object.assign(this.profile.candidate.cv, cloneDeep(cv));
        this.checkFieldsForNavigation();
        this.getFillPoints();
        return this.profile;
      });
  }

  updateBasicProfile( data: IUserProfile ): IPromise<UserProfile> {
    return this.$http.post(this.gmcApi.user.updateBasicProfile, { personal_info: data })
      .then(( res ) => {
        const newData = cloneDeep(data);
        if ( newData.candidate && newData.candidate.cv ) {
          Object.assign(this.profile.candidate.cv, newData.candidate.cv);
          delete newData.candidate; // TODO;
        }
        Object.assign(this.profile, newData);
        this.checkFieldsForNavigation();
        this.getFillPoints();
        return this.profile;
      });
  }

  deleteProfile( username: string, password: string ): IPromise<any> {
    return this.$http<IServerRes>({
      method: 'DELETE',
      url: this.gmcApi.user.deleteProfile,
      data: { userName: username, password },
      headers: { 'Content-Type': 'application/json' }
    })
      .then(( res ) => res.data);
  }

  updatePhoto( file: File ): IPromise<IUploadFileResult> {
    return this.uploadService.upload<IUploadFileResult>({
      url: `${this.gmcApi.usersApi}/saveFile/avatar`,
      method: 'POST',
      data: { file }
    })
      .then(( res ) => {
        if ( typeof res.data === 'object' ) {
          return res.data;
        } else {
          throw (res);
        }
      });
  }

  getCompanyData(): IPromise<CompanyData> {
    return this.$http.get<{ company: ICompanyData }>(this.gmcApi.company.get)
      .then(( res ) => new CompanyData(res.data.company));
  }

  updateCompanyData( company_data: CompanyData ): IPromise<any> {
    return this.$http.post<any>(this.gmcApi.company.update, { company_data })
      .then(( res ) => res.data)
      .catch((err) => err.data);
  }

  getJobExperienceItems(): IPromise<EmployerJobExperience[]> {
    return this.$http.get<{ data: IEmployerJobExperience[] }>(this.gmcApi.user.experience.getAll)
      .then(( res ) => res.data.data.map(( item ) => new EmployerJobExperience(item)));
  }

  updateJobExperienceItem( job_experience: EmployerJobExperience ): IPromise<any> {
    return this.$http.post(this.gmcApi.user.experience.update, { job_experience })
      .then(( res ) => res.data);
  }

  removeJobExperienceItem( job_id: string ): IPromise<any> {
    return this.$http({
      method: 'DELETE',
      url: this.gmcApi.user.experience.remove,
      data: {
        job_id
      },
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getHiringOnData(): IPromise<any> {
    return this.$http.get<{ hiring_on: IHiringOn }>(this.gmcApi.user.hiringOn.get)
      .then(( res ) => res.data.hiring_on);
  }

  updateHiringOnData( data: IHiringOnUpdateData[] ): IPromise<any> {
    return this.$http.post(this.gmcApi.user.hiringOn.update, { hiring_on: data })
      .then(( res ) => res.data);
  }

  checkFieldsForNavigation() {
    if ( this.profile.role_name === 'Employer' ) {
      return this.navigationUnlocked = true;
    }
    const requirements = [
      'first_name',
      'last_name',
      'personal_phone',
      'birthday',
      'country',
      'city',
      'candidate.cv.nationality'
    ];

    for ( const field of requirements ) {
      const value = get(this.profile, field);
      if ( !value ) {
        this.navigationUnlocked = false;
        break;
      }
    }
  }

  getFillPoints(): IPromise<any> {
    return this.$http.get<any>(this.gmcApi.user.profileFillPoints)
      .then(( res ) => {
          this.cvPoints = res.data.points;
          return this.cvPoints;
        }
      )
      .catch(( err ) => {
        console.log(err);
        this.cvPoints = 0;
        return this.cvPoints;
      });
  }

  getCurrentPlan(): IProfilePlan {
    console.log(this.profile);
    return this.profile && this.profile.plan;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/profile/profile.service.ts